export const BLOCK_TYPE_TEXT = 0;
export const BLOCK_TYPE_HEADER = 1;
export const BLOCK_TYPE_FOOTER = 2;


